import React, { useEffect, useState } from 'react';
import { EducationalPage } from '@/components/public/EducationalPage';
import { useLivePageContent } from '@/hooks/usePageContent';
import { coursesService } from '@/services/courses.service';
import { mediaUrl } from '@/lib/api';

const SLUG = 'in-sila';

// Testi di DEFAULT (fallback CMS): l'admin può sovrascrivere eyebrow/title/lead/hero dal CRM Pagine.
const DEFAULTS = {
  eyebrow: 'Educational',
  title: 'In Sila (in presenza)',
  lead: 'Vivi la formazione nel cuore della Sila: corsi, laboratori e percorsi esperienziali immersi nella Natura.',
  hero: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1920&q=80',
};

const euro = (n) => `€ ${Number(n || 0).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

function toCard(c) {
  return {
    id: c.id,
    title: c.title,
    text: c.short || (c.location ? `Sede: ${c.location}` : ''),
    image: c.cover ? mediaUrl(c.cover) : DEFAULTS.hero,
    price: Number(c.price) > 0 ? euro(c.price) : 'Gratis',
    to: `/educational/corso/${c.slug}`,
  };
}

export default function InSilaPresenza() {
  const cms = useLivePageContent(SLUG);
  const [courses, setCourses] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    coursesService.publicList({ mode: 'in_presenza' })
      .then((d) => { if (alive) { setCourses((d.courses || []).map(toCard)); setLoaded(true); } })
      .catch(() => { if (alive) { setCourses([]); setLoaded(true); } });
    return () => { alive = false; };
  }, []);

  return (
    <EducationalPage
      eyebrow={cms?.eyebrow || DEFAULTS.eyebrow}
      title={cms?.title || DEFAULTS.title}
      lead={cms?.lead || DEFAULTS.lead}
      hero={cms?.heroImage || DEFAULTS.hero}
      courses={loaded ? courses : []}
      emptyLabel="Nessun corso in presenza disponibile al momento"
      path="/educational/in-sila"
    />
  );
}
